import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="only-integer-input"
export default class extends Controller {

  static targets = ["numberField"];
  connect() {
    this.separateThousands();
  }

  onlyAllowNumbers() {
    const input = this.numberFieldTarget.value;
    this.numberFieldTarget.value = this.removeLeadingZeros(this.removeNonNumbers(input));
  }

  separateThousands() {
    const input = this.numberFieldTarget.value;
    this.numberFieldTarget.value = input.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  removeLeadingZeros(str)
    {
      const regex = new RegExp("^0+(?!$)",'g');
      return str.replaceAll(regex, "");
    }

  removeNonNumbers(str) {
    return str.replace(/[^0-9]/g, '').substring(0, 12);
  }
}
